// src/slices/podcast/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Get All Podcasts
export const getAllPodcasts = createAsyncThunk("podcast/getAll", async ({ page = 1 }, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/podcast/all?page=${page}`);

    return response;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});
// Get Podcast By ID
export const getPodcastById = createAsyncThunk("podcast/getById", async (id, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/podcast/${id}`);
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

// Get Podcast By Slug
export const getPodcastBySlug = createAsyncThunk("podcast/getBySlug", async (slug, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/podcast/one?identifier=${slug}`);


    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});
